<!--
  VDialog

  還原自 chunk-common.pretty.js L347。render function 已轉回 template。

  通用錯誤／提示對話框。dialog prop 帶入 { title, content, event }，
  按下確認時把 dialog.event 透過 event 事件回傳給父元件決定後續動作。

  原始的 staticRenderFns[0]（_m(0)）是 header-icon 那段靜態片段，
  轉回 template 後不需要特別處理 —— Vue 編譯時會自行判定為靜態節點。
-->

<template>
  <div class="bg-overlay align-center d-flex jc-center fd-row p-flex t-0 r-0 b-0 l-0">
    <div class="pop-container d-flex p-flex a-center jc-center">
      <div class="card small t-align-center">
        <div class="header-container">
          <div class="header-icon">
            <i class="material-icons">close</i>
          </div>
          <p class="title m-t-30 font-24">{{ dialog.title }}</p>
        </div>

        <div class="footer-container p-t-0">
          <p class="font-16 t-gray-7 m-b-24">{{ dialog.content }}</p>
          <div>
            <button class="btn btn-fill btn-red" @click="event">
              <p class="t-gray-10">{{ $t('confirm') }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dialog'],

  data() {
    return {}
  },

  methods: {
    event() {
      this.$emit('event', this.dialog.event)
    }
  },

  mounted() {}
}
</script>
